import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import * as Sentry from "@sentry/react";
import App from './App';
import ErrorBoundary from './components/ErrorBoundary';
import './index.css';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

// Initialize Sentry for error tracking
if (process.env.REACT_APP_SENTRY_DSN) {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    environment: process.env.NODE_ENV,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
    tracesSampleRate: 1.0,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  });
  console.log('✅ Sentry initialized for frontend');
} else {
  console.log('ℹ️ Sentry DSN not configured - error tracking disabled');
}

// Build info - forces unique bundle hash per build
const BUILD_TIMESTAMP = '2025-01-14T00:30:00Z';
const API_URL = process.env.REACT_APP_API_BASE_URL || 'localhost:5000';
console.log(`🚀 Build: ${BUILD_TIMESTAMP} | API: ${API_URL}`);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </ErrorBoundary>
  </React.StrictMode>
);

console.log('✅ React app initialized with future flags');

// Register service worker for offline support and PWA functionality
serviceWorkerRegistration.register({
  onSuccess: () => {
    console.log('✅ App is ready for offline use!');
  },
  onUpdate: (registration) => {
    console.log('🔄 New version available! Refresh to update.');
    // Optional: Show update notification to user
    if (window.confirm('New version available! Refresh to update?')) {
      if (registration.waiting) {
        registration.waiting.postMessage({ type: 'SKIP_WAITING' });
        window.location.reload();
      }
    }
  }
});
